import "./styles.scss";

import React from "react";
import clsx from "clsx";

const Info = ({ title, children, variant }) => {
  const parsedChildren = children
    ? Array.isArray(children)
      ? children.map((item) => item?.props?.children).filter((item) => item)
      : [children]
    : undefined;

  return (
    <div className={clsx("header-info", variant && `header-info--${variant}`)}>
      <p className="header-info__title">{title}</p>
      {parsedChildren?.length > 0 &&
        parsedChildren.map((element, index) => (
          <div key={index} className="header-info__block">
            {element}
          </div>
        ))}
    </div>
  );
};

export default Info;
